import { render } from "./AdminBasic1.vue?vue&type=template&id=59a867b1&scoped=true"
import script from "./AdminBasic1.vue?vue&type=script&lang=js"
export * from "./AdminBasic1.vue?vue&type=script&lang=js"

import "./AdminBasic1.vue?vue&type=style&index=0&id=59a867b1&scoped=true&lang=css"

import exportComponent from "/Users/yao/Documents/projects/garden/garden_ts/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59a867b1"]])

export default __exports__